import { RadioOptionType, RadioTagGroup } from "@/components/Radio/RadioTag";
import { chakra, FlexProps } from "@chakra-ui/react";
import { langStore, translate } from "@noli/business";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { genBlock } from "@/utils/bem";
import { ModeTypes, MODE_TYPES, MODE_TYPES_INFO } from "@/modules/editor/constant";
import classNames from "classnames";
import { Editor_Words } from "@/utils/lang/editor";

const block = genBlock("c-mode-switch");
const IModeSwitch: React.FC<{
  direction?: FlexProps["flexDirection"];
  className?: string;
  value?: ModeTypes;
  onChange?: (value: ModeTypes) => void;
  disabled?: boolean;
}> = ({ direction = "row", className, value, onChange, disabled }) => {
  const lang = langStore.tgt;

  const options = useMemo(
    () =>
      MODE_TYPES.map((value) => {
        const option: RadioOptionType = {
          label: translate(MODE_TYPES_INFO[value].label, lang),
          value: MODE_TYPES_INFO[value].value,
        };
        return option;
      }),
    [lang],
  );
  return (
    <RadioTagGroup
      options={options}
      title={`${translate(Editor_Words["choose-a-mode"], lang)}：`}
      className={classNames(className, block())}
      flexDirection={direction}
      useRadioGroupProps={{
        value,
        onChange,
        isDisabled: disabled,
      }}
    />
  );
};

export const ModeSwitch = chakra(observer(IModeSwitch));
